function parseTimestamp(value, preserveWallClock) {
  if (!value) return null;
  if (preserveWallClock) {
    const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?/);
    if (match) {
      return new Date(
        Number(match[1]),
        Number(match[2]) - 1,
        Number(match[3]),
        Number(match[4]),
        Number(match[5]),
        Number(match[6] || 0),
      );
    }
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDateOnly(value, options = {}) {
  if (!value) return '';
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  const date = match
    ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
    : new Date(value);
  return Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString('en-US', options);
}

export function formatDateTime(value, {
  year = 'numeric',
  preserveWallClock = false,
  includeTimeZone = false,
  separator = ', ',
} = {}) {
  const date = parseTimestamp(value, preserveWallClock);
  if (!date) return '';
  const datePart = date.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year,
  });
  const timePart = date.toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: '2-digit',
    ...(includeTimeZone ? { timeZoneName: 'short' } : {}),
  });
  return `${datePart}${separator}${timePart}`;
}

export function formatTimeOnly(value, {
  preserveWallClock = false,
  includeTimeZone = false,
} = {}) {
  const date = parseTimestamp(value, preserveWallClock);
  if (!date) return '';
  return date.toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: '2-digit',
    ...(includeTimeZone ? { timeZoneName: 'short' } : {}),
  });
}
